import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DyzioModalHeader } from 'dyzio-shared-components/lib/components/dyzio-modal';
import TextHighlighter from 'dyzio-shared-components/lib/components/text-highlighter';
import { Table, Image, Button, Modal, Icon } from 'semantic-ui-react';
import { isAutoAdded } from '../../utils/automation-utils';
import AddedBy from './added-by';

const imageStyle = {
  display: 'block',
  margin: '0 auto',
  maxHeight: 250,
};

const actionsStyle = {
  textAlign: 'center',
};

const buttonStyle = {
  width: 200,
};

const noImageWrapper = {
  textAlign: 'center',
};

const tableStyle = {
  minHeight: 300,
  margin: 0,
  padding: 0,
};

const modalContactStyle = { padding: 5 };
const smallFont = { fontSize: '80%', border: 0, color: '#444' };
const paddedCell = { padding: 30 };

const DeleteAssetDialog = ({
  onDelete,
  thumbnail,
  text,
  onClose,
  headerText,
  highlighedHashtags,
  createdBy,
  createdDate,
  trackedAsset: {
    createdBy: trackedAssetCreatedBy,
  },
}) => {
  const isPostAutoAdded = (isAutoAdded(createdBy) || (isAutoAdded(trackedAssetCreatedBy)));
  const derivedCreatedBy = createdBy || trackedAssetCreatedBy;
  const friendlyDate = moment(createdDate).format('lll');
  return (
    <Modal
      open
      onClose={onClose}
      closeOnDimmerClick
      closeOnDocumentClick
    >
      <DyzioModalHeader headerText={headerText} onClose={onClose} />
      <Modal.Content style={modalContactStyle}>
        <Table columns="two" basic="very" fixed textAlign="center" style={tableStyle}>
          <Table.Row>
            <Table.Cell>
              {
                thumbnail &&
                <Image style={imageStyle} src={thumbnail} />
              }
              {
                !thumbnail &&
                <div style={noImageWrapper}>
                  <Icon name="image" size="huge" />
                  <h3>No image available</h3>
                </div>
              }
            </Table.Cell>
            <Table.Cell style={paddedCell}>
              <TextHighlighter text={text} words={highlighedHashtags} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell style={smallFont} />
            <Table.Cell style={smallFont}>
              added by <AddedBy isAutoAdded={isPostAutoAdded} createdBy={derivedCreatedBy} />&nbsp;{friendlyDate}
            </Table.Cell>
          </Table.Row>
        </Table>
      </Modal.Content>
      <Modal.Actions style={actionsStyle}>
        <Button
          icon="trash"
          style={buttonStyle}
          color="red"
          content="delete asset"
          onClick={() => { onDelete(); onClose(); }}
        />
        <Button
          onClick={onClose}
          icon="close"
          style={buttonStyle}
          content="cancel"
        />
      </Modal.Actions>
    </Modal>
  );
};

DeleteAssetDialog.propTypes = {
  text: PropTypes.string,
  thumbnail: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  highlighedHashtags: PropTypes.array,
  createdBy: PropTypes.string.isRequired,
  createdDate: PropTypes.string.isRequired,
  trackedAsset: PropTypes.object,
};

DeleteAssetDialog.defaultProps = {
  headerText: 'Confirm delete',
  highlighedHashtags: [],
  text: 'No caption',
  trackedAsset: {},
};

export default DeleteAssetDialog;



/** WEBPACK FOOTER **
 ** ./src/components/delete-asset-dialog/index.js
 **/